import React, { ReactNode, ReactNodeArray, useRef } from 'react'

import { Box, Icon } from '@vividseats/vivid-ui-kit'
import classNames from 'classnames'
import { Swiper as SwiperType, Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import styles from '../styles.module.scss'

interface PerksSliderProps {
    title: ReactNode
    perks: ReactNodeArray
}

export const PerksSlider: React.FC<PerksSliderProps> = ({ title, perks }) => {
    const swiperRef = useRef<SwiperType>()
    const prevRef = useRef<HTMLButtonElement>(null)
    const nextRef = useRef<HTMLButtonElement>(null)

    const pagination = {
        clickable: true,
        bulletActiveClass: styles.paginationButtonActive,
        bulletClass: styles.paginationButtonInactive,
    }

    const mergedPrevButtonClasses = classNames(styles.prevButton, {
        [styles.disabledNavigation]: !!swiperRef?.current?.isBeginning,
    })

    const mergedNextButtonClasses = classNames(styles.nextButton, {
        [styles.disabledNavigation]: !!swiperRef?.current?.isEnd,
    })

    /* istanbul ignore next */
    const handleNavigationStyling = () => {
        if (!swiperRef?.current?.isBeginning) {
            prevRef.current?.classList.remove(styles.disabledNavigation)
        } else {
            prevRef.current?.classList.add(styles.disabledNavigation)
        }

        if (!swiperRef?.current?.isEnd) {
            nextRef.current?.classList.remove(styles.disabledNavigation)
        } else {
            nextRef.current?.classList.add(styles.disabledNavigation)
        }
    }

    /* istanbul ignore next */
    const handlePrevClick = () => {
        swiperRef.current?.slidePrev()
        handleNavigationStyling()
    }

    /* istanbul ignore next */
    const handleNextClick = () => {
        swiperRef.current?.slideNext()
        handleNavigationStyling()
    }

    return (
        <div className={styles.sliderWrapper} data-testid="perks-slider">
            <Swiper
                modules={[Navigation, Pagination]}
                slidesPerView={1}
                pagination={pagination}
                onBeforeInit={(swiper) => {
                    /* istanbul ignore next */
                    swiperRef.current = swiper
                }}
            >
                {perks.map((perk, index) => (
                    <SwiperSlide key={index}>
                        <Box className={styles.swiperSlider}>
                            {title}
                            {perk}
                        </Box>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div>
                <button ref={prevRef} className={mergedPrevButtonClasses} onClick={handlePrevClick}>
                    <Icon type="carat-left" />
                </button>
                <button ref={nextRef} className={mergedNextButtonClasses} onClick={handleNextClick}>
                    <Icon type="carat-right" />
                </button>
            </div>
        </div>
    )
}
